import { Navigate, Route, Routes, useMatch } from "react-router-dom"

import { useGetEnabledModulesInApp } from "@l2r-front/l2r-networks"
import { BottomSheetMobileLayout } from "@l2r-front/l2r-ui"

import { Dashboard } from "../../../modules/dashboard/components/Dashboard"
import { RoadwayMapLayersRouter } from "../../../modules/roadway/routers/RoadwayMapLayersRouter"
import { RoadwayMobileRoutes } from "../../../modules/roadway/routers/RoadwayRoutes"
import { RoadworksFilterButton } from "../../../modules/roadworks/containers/MobileFilterButton"
import { RoadworksMapLayersRouter } from "../../../modules/roadworks/routers/RoadworksMapLayersRouter"
import { RoadworksMobileRoutes } from "../../../modules/roadworks/routers/RoadworksRoutes"
import { appRoad } from "../../constants/appRoad"
import { MODULE_DASHBOARD, MODULE_ROADWAY, MODULE_ROADWORKS } from "../../constants/modules"
import { Map } from "../../containers/Map"

export function RoadMobileRouter() {

    const enabledRoadModule = useGetEnabledModulesInApp(appRoad)
    const isDetailView = useMatch(":networkId/:appId/:moduleId/:road/:detailId/*")
    return (
        <Routes>
            <Route
                path={`/${MODULE_DASHBOARD}/*`}
                element={<Dashboard />}
            />
            <Route
                path={`/${MODULE_ROADWAY}/*`}
                element={<BottomSheetMobileLayout
                    MapComponent={Map}
                    MapRouter={RoadwayMapLayersRouter}
                    BottomSheetRouter={RoadwayMobileRoutes}
                />}
            />
            <Route
                path={`/${MODULE_ROADWORKS}/*`}
                element={<BottomSheetMobileLayout
                    mapProps={{ bottomRightElements: !isDetailView && [<RoadworksFilterButton key="roadwork-filter-button" />] }}
                    MapComponent={Map}
                    MapRouter={RoadworksMapLayersRouter}
                    BottomSheetRouter={RoadworksMobileRoutes}
                />}
            />
            <Route
                path="/*"
                element={<Navigate replace to={enabledRoadModule?.[0]?.path ? enabledRoadModule?.[0]?.path : ""} />}
            />
        </Routes>
    )
}
